/* =============================
  // ハンバーガー / ドロワー
============================= */
const initDrawerMenu = (options = {}) => {
  const drawerIcon = document.querySelector('.js-hamburger');
  const drawer = document.querySelector('.js-spMenu');
  const body = document.body;
  const breakpoint = options.breakpoint ?? 864; // $break-header と一致
  let isMenuOpen = false;

  if (!drawerIcon || !drawer) {
    return {
      drawer: null,
      closeMenu: () => {},
      isMenuOpen: () => false,
    };
  }

  const closeMenu = () => {
    body.classList.remove('is-drawer-active');
    drawer.classList.remove('is-open');
    drawerIcon.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawerIcon.setAttribute('aria-expanded', 'false');
    drawerIcon.setAttribute('aria-label', 'メニューを開く');
    isMenuOpen = false;
  };

  const toggleMenu = () => {
    isMenuOpen = !isMenuOpen;
    body.classList.toggle('is-drawer-active', isMenuOpen);
    drawer.classList.toggle('is-open', isMenuOpen);
    drawerIcon.classList.toggle('is-open', isMenuOpen);
    drawer.setAttribute('aria-hidden', String(!isMenuOpen));
    drawerIcon.setAttribute('aria-expanded', String(isMenuOpen));
    drawerIcon.setAttribute(
      'aria-label',
      isMenuOpen ? 'メニューを閉じる' : 'メニューを開く',
    );
  };

  drawerIcon.addEventListener('click', toggleMenu);

  drawer.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isMenuOpen) {
      closeMenu();
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= breakpoint && isMenuOpen) {
      closeMenu();
    }
  });

  return {
    drawer,
    closeMenu,
    isMenuOpen: () => isMenuOpen,
  };
};
